module.exports = __webpack_public_path__ + "img/dongRuan.ea459db8.png";